@if (profile$ | async; as profile) {
    @if (buttonForm) {
        <div class="form-element">
            <button
                ds-button-social
                class="w-100"
                [variant]="buttonVariant"
                [socialApp]="dsProvider"
                size="large"
                [disabled]="false"
                (click)="emmitLogin(!!profile.name)">
                <span slot="start">
                    @if (buttonIcon) {
                        <vn-icon [name]="buttonIcon" />
                    }
                </span>
                {{ getLabel(profile.name) }}
            </button>
        </div>
    }
}
